export default __webpack_public_path__ + "static/fasset-4f6c074416864aba95e510d3a56178c5.svg";